/**
 * Veeroute.Lastmile
 * Veeroute Lastmile API
 *
 * The version of the OpenAPI document: 3.15.183137
 * Contact: support@veeroute.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Data for request tracing.
 */
export interface TraceDataLastmile { 
    /**
     * Unique operation code.
     */
    code: string;
    /**
     * Client ID.
     */
    client?: string;
    /**
     * Server ID.
     */
    server?: string;
    /**
     * Service name.
     */
    service?: TraceDataLastmileServiceEnum;
    /**
     * Method name.
     */
    method?: TraceDataLastmileMethodEnum;
    /**
     * Date and time service method run in the [RFC 3339, section 5.6 (ISO8601)](https://tools.ietf.org/html/rfc3339#section-5.6) format.
     */
    time?: string;
}
export enum TraceDataLastmileServiceEnum {
    LASTMILE = 'LASTMILE',
    DELIVERY = 'DELIVERY',
    FIELDSERVICE = 'FIELDSERVICE',
    MERCHANDISER = 'MERCHANDISER',
    ROUTING = 'ROUTING',
    CLUSTERING = 'CLUSTERING',
    ACCOUNT = 'ACCOUNT',
    STOCK = 'STOCK',
    ADMIN = 'ADMIN'
};
export enum TraceDataLastmileMethodEnum {
    PLAN = 'PLAN',
    REPLAN = 'REPLAN',
    ACTUALIZE = 'ACTUALIZE',
    CONVERT = 'CONVERT',
    ANALYTICS = 'ANALYTICS',
    PREDICT = 'PREDICT',
    VALIDATE = 'VALIDATE',
    ROUTE = 'ROUTE',
    MATRIX = 'MATRIX',
    CLUSTER = 'CLUSTER'
};



